import api from '../api/api';

const state = () => ({
  services: null,
  userServices: null,
	serviceLink: null
})

const mutations = {
	setServices(state, data) {
		state.services = data
	},
	setUserServices(state, data) {
		state.userServices = data
	},
	setServiceLink(state, data) {
		state.serviceLink = data
	},
	setServiceIsActive(state, payload) {
		const service = payload.service
		const isActive = payload.isActive

		if (!state.userServices) return
		
		state.userServices.data.items.forEach(userService => {
			if (userService.service == service) {
				userService.is_active = isActive
			}
		})
	},
	setServiceIsConnected(state, payload) {
		const service = payload.service

		console.log('setServiceIsConnected',payload);
		if (!state.userServices) return
		
		state.services.data.items.forEach(serviceObj => {
			if (serviceObj.service == service) {
				serviceObj.state = null
			}
		})
	}
}

const getters = {
  getServices(state) {
      return state.services
  },
	getUserServices(state) {
		return state.userServices
	},
	getServiceLink(state) {
		return state.serviceLink
	},
	getServicesAndUserServices(state) {
		const services = state.services && state.services.success && state.services.data.items
		let userServices = state.userServices && state.userServices.success && state.userServices.data.items
		
		if (!services) {
			return null
		}

		if (!userServices) {
			userServices = []
		}

		services.forEach(service => {
			service['state'] = userServices.find(userService => userService.service == service.service)
		})
		
		services.sort((a, b) => a.service == 'EmailNotifier' ? -1 : 1)
		
		return services
	}
}

const actions = {
    async GET_SERVICES({commit}, data) {
			try {
				const servicesResponse = await api.notify.services();
				
				commit('setServices', servicesResponse.data);

				return servicesResponse.data;
			} catch (err) {
				
				commit('setServices', err.response);
				return err.response;
			}
    },
		async GET_USER_SERVICES({commit}, data) {
			try {
				const userServicesResponse = await api.notify.find(data);
				
				commit('setUserServices', userServicesResponse.data);

				return userServicesResponse.data;
			} catch (err) {
				
				commit('setUserServices', err.response);
				return err.response;
			}
    },
		async GET_SERVICE_LINK({commit}, service) {
			try {
				const serviceLinkResponse = await api.notify.link({
					service
				});

				commit('setServiceLink', serviceLinkResponse.data);

				return serviceLinkResponse.data;
			} catch (err) {

				commit('setServiceLink', err.response)
				return err.response;
			}
		},
		async UNLINK_SERVICE({commit}, service) {
			try {
				const unlinkServiceResponse = await api.notify.unlink({
					service
				});

				return unlinkServiceResponse.data;

			} catch (err) {
				return err.response;
			}
		},
		async CHANGE_ACTIVE_STATUS({commit}, payload) {
			try {
				const activeResponse = await api.notify.active(
					{service: payload.service}, 
					{isActive: payload.isActive}
				);

				return activeResponse.data;

			} catch (err) {
				return err.response;
			}
		},
}


const notify = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}

export default notify;